import { apiNps } from '../../../services/api-http';


class SurveyService {
  getTags = () => {
    return apiNps.get(`tags`);
  };

  getSurveyConfig = (surveyId) => {
    return apiNps.get(`configuration/survey/${surveyId}`);
  };

  sendInquiry = (pendingSurveyId, rate) => {
    return apiNps.post(
      `/satisfaction/survey/add-response-webchat`,
      {
        pendingSurveyId,
        rate
      }
    );
  };
}

export default new SurveyService();
